<template>
<div ref="drop-container">
    <div v-if="this.$route.fullPath.includes('tab1')" >
      <div v-for="img in this.imgList" :key="img.pictureid">
      <img :src="img.blob" class="finishedimage" />
      <i
        style="vertical-align: top;position: relative;
                left: -11px;
                bottom: 8px;
                color:rgb(89, 89, 89);"
        class="el-icon-error"
        @click="removeImageFromFormSubmit(img)"
      ></i>
    </div>
    </div>
    <div v-else>
      <div v-for="img in this.imgListIssues" :key="img.pictureid">
      <img :src="img.blob" class="finishedimage" />
      <i
        style="vertical-align: top;position: relative;
                left: -11px;
                bottom: 8px;
                color:rgb(89, 89, 89);"
        class="el-icon-error"
        @click="removeImageFromFormSubmit(img)"
      ></i>
    </div>
    </div>
</div>
</template>

<script>
import EventBus from '@/services/EventBus.js';


export default {

    data(){
        return{
          imgList: [],
          imgListIssues: []
        }
    },

   mounted(){

    EventBus.$on( "new-load-dropped", ($event) => {
        this.imgList = $event;
      })

    EventBus.$on( "new-load-dropped-issues", ($event) => {
        this.imgListIssues = $event;
      })

   },
   methods: {
           removeImageFromFormSubmit(img) {
    if(this.$route.fullPath.includes("tab1")){
        
        this.$delete(this.imgList, this.imgList.indexOf(img));
    } else {
         this.$delete(this.imgListIssues, this.imgListIssues.indexOf(img));
    }

      var currentImageId = img.pictureid;
    if(this.$route.fullPath.includes("tab1")){

      this.$emit("removePictureId", currentImageId);
    }
     else {
       this.$emit("removePictureIdIssues", currentImageId);
      }
    },
   }

}
</script>

<style>

</style>